import React, { useContext, useState, useEffect } from 'react';
import { ArrowRightOutlined, LoadingOutlined, ArrowLeftOutlined, LockOutlined, CheckOutlined, EditOutlined, CloseOutlined, UserAddOutlined, DownloadOutlined, MessageOutlined, ExclamationCircleOutlined, UndoOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Row, Col, Button, Divider, Tooltip, Avatar, Dropdown, Menu, Popover, Input, Breadcrumb, Badge } from 'antd';
import CollaborateContext from '../../ContextFiles/CollaborateContext';
import CollaborateConstants from './Constants';
import ProductPageConstants from '../ProductComponents/ProductPageConstants';
import './CollaborateTool.scss'
import * as Utilities from '../../Utilities';
import ENVIRONMENT from '../../../../environments';

const CollaborateAiNavBar = () => {
    const { display_name, refreshLoader, save_loader, scene_creator_loader, exitTool, goToSceneCreator,
        initialLoader, access_level, setCollaborateAccessModal, annotateLoader, convertToPDF, imageFormat,
        setVersionHistoryVisible, openCommentHistory, activeCollaboratorList, original_img_url,
        setResolveConfirmModal, isCollaborationResolved, currentVersion, isOldVersion, versionName, setVersionName, 
        collaboration_id, render_name, scene_id, setDisplayName, updtateVersionNameInHistory, product_id, image_id, collaborators,
        setRejectionHistoryVisible, rejectionHistory, handleEditClick, handleGenerateMore } = useContext(CollaborateContext);
    const activeName = isOldVersion ? versionName : display_name;
    const [isEditName, setIsEditName] = useState(false);
    const [name, setName] = useState(activeName);
    const [nameLoader, setNameLoader] = useState(false);
    const [allUsersActiveStatus, setAllUsersActiveStatus] = useState([]);
    
    const CUSTOMER_USERNAME = localStorage.getItem('username');
    const USER_ROLE = localStorage.getItem('user_role') || 'normal';

    useEffect(() => {
        if (!collaborators) return;
        
        const updatedList = collaborators
        .map(user => ({
            ...user,
            active:
            user.username === CUSTOMER_USERNAME ||
            activeCollaboratorList.some(activeUser =>
                activeUser.customer_username === user.username
            )
        }))
        .filter(user => user.active); // Only keep active users

        const colorMap = {};
        let colorIndex = 0;
        updatedList.forEach((item) => {
            if (!colorMap[item.username]) {
                colorMap[item.username] = ProductPageConstants.avatar_colors[colorIndex % ProductPageConstants.avatar_colors.length];
                colorIndex++;
            }
        });

        let colorUpdatedList = updatedList.map((item) => ({
            ...item,
            avatar_color: colorMap[item.username]
        }));
        
        setAllUsersActiveStatus(colorUpdatedList);
    }, [collaborators, activeCollaboratorList]);

    // Function to generate the download dropdown menu
    const downloadMenu = (
        <Menu>
            <Menu.Item key={0}>
                <div className='manrope f-14 black-55' onClick={() => Utilities.downloadFile(original_img_url, display_name, imageFormat)}>Download Image</div>
            </Menu.Item>
            <Menu.Item key={1}>
                <div className='manrope f-14 black-55' onClick={convertToPDF}>Download PDF</div>
            </Menu.Item>
        </Menu>
    );

    const handleNameSubmit = () => {
        if (isOldVersion) {
            updateCollaborationHistoryName();
        } else {
            updateCollaborationName();
        }
    }

    const handleNameChange = (e) => {
        setName(e.target.value)
    }

    const handleEditCancel = () => {
        setIsEditName(false)
        setName(activeName)
    }

    const updateCollaborationName = () => {
        let aiImagePayload = {
            id: `${image_id}`,
            display_name: name,
            action: 'edit_ai_image_name'
        }
        axios.post(ENVIRONMENT.AI_MODEL_HELPER, aiImagePayload)
        
        let collabNamePayload = {
            collaboration_id: collaboration_id,
            display_name: name,
            action: 'update_display_name_by_id'
        }
        axios.post(ENVIRONMENT.COLLABORATION_ENTITY_UPDATE, collabNamePayload)
        .then(res => {
            setNameLoader(false);
            setDisplayName(name);
            setIsEditName(false);
        })
        .catch(err => {
            console.error('Error updating review image name:', err);
        });
    }

    const updateCollaborationHistoryName = () => {
        let payload = {
            'collaboration_id': collaboration_id,
            'version_number': currentVersion,
            'display_name': name,
            'action': 'update_display_name'
        }
        setNameLoader(true)
        axios.post(ENVIRONMENT.COLLABORATION_RENDER_HISTORY_UPDATE, payload)
            .then(res => {
                setVersionName(name);
                setNameLoader(false);
                setIsEditName(false);
                updtateVersionNameInHistory(name, currentVersion)
            })
    }

    return (
        <div className="collaborate-navbar">
            <Row type="flex" className="w-100 display-flex j-s-b">
                <Col span={8} className='display-flex j-s a-c'>
                    <Tooltip title={<span className='manrope f-12 white'>Go back</span>} placement='bottom'>
                    <ArrowLeftOutlined className="action-icon-btn grey mr-16" onClick={exitTool} />
                    </Tooltip>
                    <div className='ai-gradient-container' style={{background: 'None', marginRight: '8px'}}>
                        <img src="/img/ai_creator/ai-twinkle-high-res.svg" />
                        <span className='manrope f-14 w-600 lh-28 ai-gradient ml-4'>AI</span>
                    </div>
                    { display_name &&
                    <Breadcrumb className='justify-in-start'>
                        {isOldVersion && 
                        <Breadcrumb.Item>
                            <Tooltip title={<span className='manrope f-12 white'>{display_name}</span>} placement='bottom'>
                                <span onClick={exitTool} className='manrope f-16 w-400 grey-8c clamp-w-150 pointer'>
                                    {display_name.length > 20 ? display_name.substring(0, 20) + "..." : display_name}
                                </span>
                            </Tooltip>
                        </Breadcrumb.Item>}
                        <Breadcrumb.Item>
                        <Row type="flex" style={{display:"inline-block"}}>
                            <Col span={24} className='display-flex j-s a-c'>
                                {(isEditName) ?
                                <div id="name_form" className='manrope f-16 w-400 grey-8c nameEditField'>
                                    <Input className='manrope f-16' style={{width:"90%"}} value={name} onChange={handleNameChange} bordered={false} />
                                    <div className='nameEditIcons'>
                                        {nameLoader ?
                                        <LoadingOutlined className='ml-16' /> :
                                        <>
                                            <CloseOutlined className='nameIcon' onClick={handleEditCancel} />
                                            <CheckOutlined className='nameIcon' onClick={handleNameSubmit} />
                                        </>}
                                    </div>
                                </div> :
                                <div className='display-flex j-s a-c'>
                                    <Tooltip title={<span className='manrope f-12 white'>{activeName || `version ${currentVersion}`}</span>} placement='bottom'>
                                        <h3 className='manrope f-20 w-500 black-00 capitalize clamp-text w-200px mb-0'>
                                            {activeName || `version ${currentVersion}`}
                                        </h3>
                                    </Tooltip>
                                    {(scene_id || image_id) &&
                                    <EditOutlined className='ml-10' onClick={()=> {
                                        setIsEditName(true)
                                        setName(activeName)}} />
                                    }
                                </div>
                                }
                                </Col>
                            </Row>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    }
                </Col>

                {(CollaborateConstants.edit_access_levels.includes(access_level)) ?
                    <Col span={8} className='display-flex j-e a-c'>
                        {allUsersActiveStatus.slice(0, 4).map((collaborator, index) => (
                            <Tooltip
                                key={index}
                                placement="bottom"
                                title={
                                    <span className="manrope f-12 white">
                                        {collaborator.profile_name || collaborator.username}
                                    </span>
                                }
                            >
                                <div
                                    style={{
                                        display: 'inline-flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: 44,
                                        position: 'relative',
                                        marginRight: 8,
                                    }}
                                >
                                    <Badge
                                        count={
                                            collaborator.active ? (
                                                <span
                                                    style={{
                                                        backgroundColor: '#52C41A',
                                                        width: 14,
                                                        height: 14,
                                                        borderRadius: '50%',
                                                        display: 'inline-block',
                                                        border: '2px solid white',
                                                    }}
                                                />
                                            ) : null
                                        }
                                        offset={[-5, 5]}
                                    >
                                        <Avatar
                                            className="cursor-pointer manrope f-16 black lh-24"
                                            style={{ backgroundColor: collaborator.avatar_color }}
                                            size={38}
                                        >
                                            {Utilities.getInitials(
                                                collaborator.profile_name
                                                    ? collaborator.profile_name
                                                    : collaborator.username
                                            )}
                                        </Avatar>
                                    </Badge>

                                    {(collaborator.access_level == 'owner' || collaborator.access_level == 'co-owner') && (
                                        <span 
                                            className="manrope black f-9 lh-16 w-700 justify-in-center capitalize"
                                            style={{
                                                position: 'absolute',
                                                bottom: -5,
                                                background: 'white',
                                                borderRadius: 2,
                                                padding: '0px 4px',
                                                boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
                                                height: '16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {collaborator.access_level}
                                        </span>
                                    )}
                                </div>
                            </Tooltip>
                        ))}

                        {allUsersActiveStatus.length > 4 && (
                            <div>
                                <Avatar
                                    className="cursor-pointer manrope f-16"
                                    onClick={() => setCollaborateAccessModal(true)}
                                    style={{lineHeight: '48px', width: '48px', height: '48px'}}>
                                    +{allUsersActiveStatus.length - 4}
                                </Avatar>
                            </div>
                        )}

                        <Tooltip title={<span className='manrope f-12 white'>Invite Collaborators</span>} placement='bottom'>
                            <Button
                                className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8 ml-6'
                                ghost
                                onClick={() => setCollaborateAccessModal(true)}
                            >
                                <UserAddOutlined />
                            </Button>
                        </Tooltip>

                        {allUsersActiveStatus.length > 0 && <Divider type="vertical" className='collab-nav-divider mr-16' />}
                        
                        <Tooltip title={<span className='manrope f-12 white'>Download Options</span>} placement='bottom'>
                            <Dropdown overlay={downloadMenu} trigger={['click']}>
                                <Button
                                    className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                    ghost
                                >
                                    <DownloadOutlined />
                                </Button>
                            </Dropdown>
                        </Tooltip>

                        {(scene_id || image_id) && 
                        <Tooltip title={<span className='manrope f-12 white'>Version History</span>} placement='bottom'>
                            <Button
                                className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                ghost
                                onClick={() => setVersionHistoryVisible(true)}
                            >
                                <img src={'/img/collaborate_tool/version_history_black.svg'}/>
                            </Button>
                        </Tooltip>}

                        {(image_id && rejectionHistory && rejectionHistory.length > 0) && 
                        <Tooltip title={<span className='manrope f-12 white'>Rejection History</span>} placement='bottom'>
                            <Button
                                className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                ghost
                                onClick={() => setRejectionHistoryVisible(true)}
                            >
                                <ExclamationCircleOutlined />
                            </Button>
                        </Tooltip>}

                        <Tooltip title={<span className='manrope f-12 white'>Comment History</span>} placement='bottom'>
                            <Badge dot offset={[-21, 11]}
                                style={{ backgroundColor: '#D93025', width: 10, height: 10, minWidth: 10}}
                            >
                                <Button
                                    className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                    ghost
                                    onClick={openCommentHistory}
                                >
                                    <MessageOutlined />
                                </Button>
                            </Badge>
                        </Tooltip>

                        {
                            (USER_ROLE != 'reviewer') ?
                                <>
                                    <Tooltip title={<span className='manrope f-12 white'>Generate more</span>} placement='bottom'>
                                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn mr-8' onClick={handleGenerateMore}>
                                            <UndoOutlined style={{ fontSize: '16px', transform: 'scaleX(-1)' }} />
                                        </Button>
                                    </Tooltip>

                                    <Button 
                                        icon={<EditOutlined />}
                                        className="product-btn black f-14"
                                        style={{padding: '12px 16px', display: 'flex', alignItems: 'center'}}
                                        onClick={handleEditClick}
                                    >
                                        Open Image Editor
                                    </Button>
                                </>
                                :
                                ''
                        }

                    </Col> : (["restricted", "view"].includes(access_level)) ? <Col span={8} className="display-flex j-e a-c">
                        {(["view"].includes(access_level)) &&
                            <Tooltip title={<span className='manrope f-12 white'>Comment History</span>} placement='bottom'>
                                <Badge dot offset={[-21, 11]}
                                    style={{ backgroundColor: '#D93025', width: 10, height: 10, minWidth: 10}}
                                >
                                    <Button
                                        className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                        ghost
                                        onClick={openCommentHistory}
                                    >
                                        <MessageOutlined />
                                    </Button>
                                </Badge>
                            </Tooltip>}
                        {(["view"].includes(access_level)) && (scene_id || image_id) &&
                            <Tooltip title={<span className='manrope f-12 white'>Version History</span>} placement='bottom'>
                                <Button
                                    className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                    ghost
                                    onClick={() => setVersionHistoryVisible(true)}
                                >
                                    <img src={'/img/collaborate_tool/version_history_black.svg'}/>
                                </Button>
                            </Tooltip>}

                        {(["view"].includes(access_level)) && (image_id && rejectionHistory && rejectionHistory.length > 0) &&
                            <Tooltip title={<span className='manrope f-12 white'>Rejection History</span>} placement='bottom'>
                                <Button
                                    className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                    ghost
                                    onClick={() => setRejectionHistoryVisible(true)}
                                >
                                    <ExclamationCircleOutlined />
                                </Button>
                            </Tooltip>}

                        {(["view"].includes(access_level)) &&
                            <Tooltip title={<span className='manrope f-12 white'>Download Options</span>} placement='bottom'>
                                <Dropdown overlay={downloadMenu} trigger={['click']}>
                                    <Button
                                        className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                        ghost
                                    >
                                        <DownloadOutlined />
                                    </Button>
                                </Dropdown>
                            </Tooltip>
                        }
                        {
                            isCollaborationResolved ?
                            <Button 
                                disabled={true} 
                                className='product-btn disabled-grey f-14 ml-12'
                                style={{padding: '10px 16px'}}
                            >
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    Collaboration Resolved&nbsp;&nbsp;
                                    <CheckOutlined />
                                </span>
                            </Button>
                            :
                            <Tooltip placement='left' title={
                                <span className='manrope f-12 white'>
                                    {
                                        isOldVersion ? "You are viewing an old version of this collaboration. Changes cant be made." : `You have ${access_level} access to this collaboration.`
                                    }
                                </span>}>
                                <LockOutlined className='access-icon ml-12' />
                            </Tooltip>
                        }
                    </Col> : ""}
            </Row>
        </div>
    );
}


export default CollaborateAiNavBar;
